import { API_URLS } from '../../../configs/constants/urls.js';
import { appendXsrfToken, onError } from '../../../helpers/request/utils.js';
import { createPostRequest } from '../../../helpers/request/request.js';
import { modifyUtagDataAfterLoginsAndRegistrations } from '../../../tracking/tools.js';
import TokenService from '../../../helpers/request/tokens.js';
export const sendRegistrationBffRequest = async ({ email, password, loginAfterSuccess = true, consent, }) => {
    try {
        if ((await TokenService.getCsrfToken()) !== true) {
            return onError();
        }
        const requestOptions = appendXsrfToken({});
        const response = await createPostRequest(API_URLS.BFF.REGISTRATION, {
            email,
            password,
            loginAfterSuccess,
            consent,
        }, requestOptions);
        await modifyUtagDataAfterLoginsAndRegistrations();
        return response.data;
    }
    catch (error) {
        const typedError = error;
        throw typedError.response.status;
    }
};
//# sourceMappingURL=registration.js.map